import React from 'react';
import {ShowForTabletMode} from './hide-for-tablet-mode';
import Button from './button/button';
import {FormattedMessage} from 'react-intl';
import {useNavigate} from 'react-router-dom';

export default React.memo((e) => {
  const navigate = useNavigate();
  const refreshPage = () => {
    navigate(0);
  };
  return (
    <div className='padding-1rem'>
      <h1>Application Error</h1>
      <pre style={{whiteSpace: 'pre-wrap'}}>{e.error.toString()}</pre>
      <ShowForTabletMode>
        <div className='padding-top-1rem'>
          <Button {...{color: 'orange-gradient', size: 'md', clickHandler: refreshPage}}>
            <FormattedMessage defaultMessage='Reload page'/>
          </Button>
        </div>
      </ShowForTabletMode>
    </div>
  );
});

